/**
 * AssetTypeSelector Component
 * Dropdown for selecting the asset type (headline, description, sitelink, etc.)
 */

import React from 'react';
import type { AssetTypeSelectorProps, TextAssetType } from '../types';
import { TEXT_ASSET_LABELS } from '../types';

export function AssetTypeSelector({
  assetTypes,
  selectedType,
  onChange,
  disabled = false,
}: AssetTypeSelectorProps) {
  // If selected type is not in available types, reset to first available
  React.useEffect(() => {
    if (assetTypes.length > 0 && !assetTypes.includes(selectedType)) {
      onChange(assetTypes[0]);
    }
  }, [assetTypes, selectedType, onChange]);

  if (assetTypes.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic">
        No text assets available at this level
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <label
        htmlFor="asset-type-select"
        className="text-sm font-medium text-gray-700 whitespace-nowrap"
      >
        Asset type:
      </label>
      <select
        id="asset-type-select"
        value={selectedType}
        onChange={(e) => onChange(e.target.value as TextAssetType)}
        disabled={disabled}
        className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed text-sm"
      >
        {assetTypes.map((type) => (
          <option key={type} value={type}>
            {TEXT_ASSET_LABELS[type] || type}
          </option>
        ))}
      </select>
    </div>
  );
}

export default AssetTypeSelector;
